import { gql } from '@urql/core';
import { YouTubeVideo } from '../../common/media/YouTubePlayer';
import React from 'react';
import { CollegeDetailsFragment, CollegeMediaCardFragment } from '../../../generated/spin-graphql';
import Image from 'next/image';
import { buildFileUrlOrNull } from '../../../client/images.utils';
import { SpinContentImageDisplay } from '../../common/media/SpinContentImageDisplay';

gql`
    fragment CollegeMediaCard on espin_college {
        name
        program_name
        header_media_link {
            link_type
            link_data
        }
        college_images {
            file {
                ...SpinContentImageDisplay
            }
        }
    }
`;

type Props = {
    college: CollegeMediaCardFragment;
};

export const CollegeMediaCard: React.FC<Props> = ({ college }) => {
    const ytId = college.header_media_link?.link_data;

    return (
        <div className="profile-card">
            <div className="title-container no-pad">
                <h2 className="title">We are {college.program_name}</h2>
                <div className="media-container">
                    {college.header_media_link?.link_data && <YouTubeVideo youtubeId={ytId} />}
                    {college.college_images.length != 0 && (
                        <div className="gallery">
                            {college.college_images.map((image, index) => {
                                return (
                                    <div key={`image-${index}`} className="gallery-image-wrapper">
                                        <div className="gallery-image">
                                            <SpinContentImageDisplay
                                                img={image.file}
                                                objectFit="cover"
                                                layout="fill"
                                                objectPosition="center"
                                                alt={`Gallery Image ${index}`}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
